<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12 sm8>
        <v-card class="elevation-12 default-border">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{
              this.$route.params.id
                ? "Edição de usuário"
                : "Cadastro de usuário"
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              v-model="formularioCadastroValido"
              ref="formularioCadastroRef"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.nome"
                      color="secondary"
                      :rules="regras.nome"
                      prepend-icon="person"
                      label="Nome"
                      type="text"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.email"
                      color="secondary"
                      :rules="regras.email"
                      prepend-icon="mail"
                      label="E-mail"
                      type="text"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="cadastroModel.conta"
                      color="secondary"
                      :rules="regras.nome"
                      :items="listaContas"
                      item-text="nome"
                      prepend-icon="account_balance"
                      label="Franquia"
                      required
                      return-object
                      :disabled="usuarioLogado.idtipousuario == 0"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="cadastroModel.tipoUsuario"
                      color="secondary"
                      :rules="regras.nome"
                      :items="listaTipoUsuario"
                      item-text="tipoUsuario"
                      prepend-icon="supervised_user_circle"
                      label="Tipo Usuário"
                      :disabled="usuarioLogado.idtipousuario == 0"
                      required
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-switch
                      :label="`${cadastroModel.ativo ? 'Ativo' : 'Inativo'}`"
                      v-model="cadastroModel.ativo"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Senha"
                      id="campoSenha"
                      v-model="cadastroModel.senha"
                      :rules="senhaRule"
                      :type="!verSenha ? 'password' : 'text'"
                      :append-icon="!verSenha ? 'visibility' : 'visibility_off'"
                      @click:append="() => (verSenha = !verSenha)"
                      @keydown.enter.prevent
                      :disabled="this.$route.params.id != null"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Repita a senha"
                      id="campoRepitaSenha"
                      v-model="cadastroModel.repitaSenha"
                      :rules="confirmacaoSenhaRule"
                      :type="!verRepitaSenha ? 'password' : 'text'"
                      :append-icon="
                        !verRepitaSenha ? 'visibility' : 'visibility_off'
                      "
                      @click:append="() => (verRepitaSenha = !verRepitaSenha)"
                      @keydown.enter.prevent
                      :disabled="this.$route.params.id != null"
                      required
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <dropzone
                      v-on:urlArquivo="definirUrlFile"
                      v-on:removedfile="removerUrlFile"
                    ></dropzone>
                  </v-flex> -->
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              id="voltar"
              color="primary"
              class="grey--text text--darken-1"
              :to="{ name: 'Usuarios' }"
              :disabled="usuarioLogado.idtipousuario == 0"
              flat
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              id="finalizar"
              color="primary"
              class="default-border"
              depressed
              @click="finalizar"
              :disabled="disableBtnFinalizar || !formValid"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="5000"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      bottom
      multi-line
      v-model="snackbarModel.mostrar"
    >
      {{ snackbarModel.text }}
      <v-btn
        flat
        dark
        @click.native="
          `${
            snackbarModel.sucesso
              ? go('Usuarios')
              : (snackbarModel.mostrar = false)
          }`
        "
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import cipher from "@/helpers/cipher.js";
import jwt from "@/helpers/jwt";
import permissoes from "@/helpers/permissoes.js";
import usuarioHelper from "@/helpers/usuario.js";
import perfil from "@/helpers/perfil.js";
import Dropzone from "@/components/compartilhados/Dropzone";
export default {
  name: "CadastroUsuario",
  components: {
    Dropzone,
  },
  data: () => ({
    maskTelefone: "(##)#####-####",
    arquivoSelecionado: false,
    formularioCadastroValido: false,
    regras: {
      email: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Você precisa informar um e-mail válido",
      ],
      nome: [(v) => !!v || "Você não pode deixar este campo em branco"],
      telefoneComercial: [
        (v) => !!v || "Você não pode deixar este campo em branco",
      ],
      senha: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) => v.length >= 8 || "A senha deve ter 8 ou mais caracteres",
      ],
      repitaSenha: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) => v.length >= 8 || "A senha deve ter 8 ou mais caracteres",
      ],
    },
    cadastroModel: {
      idUsuario: null,
      nome: "",
      email: "",
      tipoUsuario: null,
      senha: "",
      repitaSenha: "",
      conta: null,
      ativo: true,
      urlAvatar: null,
    },
    snackbarModel: {
      mostrar: false,
      text: "",
      sucesso: false,
    },
    listaContas: [],
    listaTipoUsuario: [],
    disableBtnFinalizar: false,
    verSenha: false,
    verRepitaSenha: false,
  }),
  computed: {
    formValid: function () {
      return this.formularioCadastroValido;
    },
    cipherComputed: function () {
      return cipher;
    },
    senhaRule: function () {
      return [
        (this.cadastroModel.senha != undefined &&
          this.cadastroModel.senha != null &&
          this.cadastroModel.senha != "") ||
          "Você não pode deixar este campo em branco",
        this.cadastroModel.senha.length >= 8 ||
          "A senha deve ter no mínimo 8 caracteres",
      ];
    },
    confirmacaoSenhaRule: function () {
      return [
        this.cadastroModel.senha == this.cadastroModel.repitaSenha ||
          "Confirme corretamente a sua senha",
      ];
    },
    contaMetta: function () {
      return `${process.env.ID_CONTA_METTA}`;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
  },
  watch: {
    $route(to, from) {
      const self = this;
      self.$refs.formularioCadastroRef.reset();
      this.cadastroModel.ativo = false;
    },
  },
  mounted: function () {
    this.buscarConta();
    this.validaPerfilUsr();
    this.buscarUsuario();
  },
  methods: {
    definirUrlFile: function (url) {
      const self = this;
      if (self.cadastroModel.urlAvatar != null) {
        self.$http
          .get(
            `${process.env.URL_API}/arquivo/v1/file/delete/` +
              self.cadastroModel.urlAvatar
                .split("?")[0]
                .split("/")
                .slice(-1)[0],
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            //console.log(response.data);
          });
      }
      self.cadastroModel.urlAvatar = url;
      self.arquivoSelecionado = true;
    },
    removerUrlFile: function () {
      this.cadastroModel.urlAvatar = "";
      this.arquivoSelecionado = false;
    },
    validaPerfilUsr: function () {
      const self = this;
      if (
        usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
      ) {
        self.listaTipoUsuario.push({
          idTipoUsuario: 5,
          tipoUsuario: "Administrador",
        });
        self.listaTipoUsuario.push({
          idTipoUsuario: 3,
          tipoUsuario: "Operador Master",
        });
        self.listaTipoUsuario.push({
          idTipoUsuario: 4,
          tipoUsuario: "Secretária Master",
        });

        self.listaTipoUsuario.push({
          idTipoUsuario: 0,
          tipoUsuario: "Cliente Metta Bank",
        });
      }
      if (
        usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.franquiado
      ) {
        self.listaTipoUsuario.push({
          idTipoUsuario: 2,
          tipoUsuario: "Franquiado",
        });
        self.listaTipoUsuario.push({
          idTipoUsuario: 6,
          tipoUsuario: "Biomedicina",
        });
      }
      if (usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador) {
        self.listaTipoUsuario.push({
          idTipoUsuario: 1,
          tipoUsuario: "Operador",
        });
      }

      if (usuarioHelper.USUARIO_LOGADO().idconta == self.contaMetta) {
        self.listaTipoUsuario.push({
          idTipoUsuario: 0,
          tipoUsuario: "Cliente Metta Bank",
        });
      }
    },
    getPermissao: function (requested, param) {
      const permissionObj = permissoes;
      if (param) {
        return eval(
          "permissionObj." +
            this.$route.name +
            "." +
            requested +
            "(" +
            param +
            ")"
        );
      } else {
        return eval("permissionObj." + this.$route.name + "." + requested);
      }
    },
    buscarConta: function () {
      const self = this;
      const item = jwt.decryptToken();

      if (item != null) {
        if (item.idtipousuario == 5) {
          self.$http
            .get(`${process.env.URL_API}/conta/v1/busca/`, {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            })
            .then(function (response) {
              self.listaContas = response.data;
              self.listaContas.sort(self.compareNome);
            });
        } else if (item.idtipousuario == 2) {
          self.$http
            .get(`${process.env.URL_API}/conta/v1/busca/` + item.idconta, {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            })
            .then(function (response) {
              self.listaContas = response.data;
              self.listaContas.sort(self.compareNome);
            });
        }
      } else {
        self.go("Login");
      }
    },
    buscarUsuario: function () {
      const self = this;

      const item = jwt.decryptToken();
      if (item != null) {
        if (
          this.$route.params.id &&
          Number.isInteger(parseInt(cipher.decrypt(this.$route.params.id)))
        ) {
          self.$http
            .get(
              `${process.env.URL_API}/usuario/v1/busca/` +
                cipher.decrypt(this.$route.params.id),
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const resposta = response.data[0];

              self.cadastroModel.idUsuario = resposta.idUsuario;
              self.cadastroModel.nome = resposta.nome;
              self.cadastroModel.email = resposta.email;
              self.cadastroModel.tipoUsuario = resposta.tipoUsuario;

              if (item.idtipousuario != 5 || item.idtipousuario != 2) {
                self.listaContas.push(resposta.conta);
              }

              self.cadastroModel.conta = resposta.conta;
              self.cadastroModel.ativo = resposta.ativo;
              self.cadastroModel.urlAvatar = resposta.urlAvatar;

              self.cadastroModel.senha = "12345678";
              self.cadastroModel.repitaSenha = "12345678";
            });
        } else {
          self.go("CadastroUsuario");
        }
      } else {
        self.go("Login");
      }
    },
    compareNome: function (a, b) {
      const bandA = a.nome.toUpperCase();
      const bandB = b.nome.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    finalizar: function () {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          if (!self.$route.params.id) {
            self.cadastroModel.idUsuario = "";
            self.$http
              .post(
                `${process.env.URL_API}/usuario/v1/cadastro`,
                self.cadastroModel,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  self.go("Usuarios", {
                    snackbarText: data.mensagem,
                    snackbarMostrar: true,
                    snackbarSucesso: data.sucesso,
                  });
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          } else {
            self.cadastroModel.idUsuario = cipher.decrypt(
              self.$route.params.id
            );
            self.$http
              .post(
                `${process.env.URL_API}/usuario/v1/edicao`,
                self.cadastroModel,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  if (self.usuarioLogado.idtipousuario == 0) {
                    self.disableBtnFinalizar = data.sucesso;
                    self.go("Portal", {
                      snackbarText: data.mensagem,
                      snackbarMostrar: true,
                      snackbarSucesso: data.sucesso,
                    });
                  } else {
                    self.disableBtnFinalizar = data.sucesso;
                    self.go("Usuarios", {
                      snackbarText: data.mensagem,
                      snackbarMostrar: true,
                      snackbarSucesso: data.sucesso,
                    });
                  }
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          }
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/usuarios/CadastroUsuario.vue